import Vue from 'vue'
import {dd,store,app} from 'systems/imports'

import BaseProcessor from 'processor/BaseProcessor'
import API from 'api/Event'

/**
 * 運営サイト情報
 */
class Event extends BaseProcessor{
  static getClassName(){ return 'Event' }

  /**
   */
  static getEvent(input){
    return new Promise(function(resolve, reject) {
      API.getEvent(input)
        .then((res)=>{
          return resolve({status:"ok",data:{event:res.event} })
        }).catch((e)=>{
        switch(e.name){
        }
      })
    });
  }

  /**
   */
  static getViewingEvents(input){
    return new Promise(function(resolve, reject) {
      API.getViewingEvents(input)
        .then((res)=>{
          return resolve({status:"ok",data:{events:res.events} })
        }).catch((e)=>{
        switch(e.name){
        }
      })
    });
  }

  static isEventActivated(input){
    return new Promise(function(resolve, reject) {
      API.isEventActivated(input)
        .then((res)=>{
          return resolve({status:"ok",data:{is_activated:res.is_activated} })
        }).catch((e)=>{
        switch(e.name){
        }
      })
    });
  }

  static eventKeyActivation(input){
    return new Promise(function(resolve, reject) {
      API.eventKeyActivation(input)
        .then((res)=>{
          return resolve({status:"ok",data:{} })
        }).catch((e)=>{
        switch(e.name) {
          case "data_not_exist":
            return resolve({status: "ng", data: {}, apiErrorI18nKey: "error['5_1'][8]"})
        }
      })
    });
  }



}

export default Event



// WEBPACK FOOTER //
// ./src/processor/Event.js